import { Heading, Loader } from "@/components";
import useCommunities from "./useCommunities";
import { Button } from "@/components/ui";
import { OwnerAddEditCommunity } from "./AddEditCommunity";
import {
  COMM_USERS,
  COMMUNITY,
  PROPERTIES,
  USERS,
  VIEW_PROPERTY,
  VIEW_USERS,
} from "./consts";
import { OwnerProperties, OwnerAddEditProperty } from "./Properties";
import { OwnerAddEditUser, OwnerUsers } from "./Users";
import { OwnerUsersList } from "./UsersList";
import { cn } from "@/lib/utils";

const Communities = () => {
  const {
    isLoadingCommunity,
    communityDetails,
    onViewMoreClick,
    onShowProperty,
    onShowUsers,
    myCommunityCurrView,
    isBom,
  } = useCommunities();

  return (
    <div className="p-4 md:p-6">
      <Heading title={"My Community"} />
      <div className="pt-4">
        {isLoadingCommunity ? (
          <Loader />
        ) : (
          <>
            <div className="bg-gray-700 rounded-md p-[15px]">
              <div className="grid grid-cols-1 md:grid-cols-3 lg:grid-cols-4 gap-3 rounded-md text-white bg-gray-600 p-[15px]">
                <div className="flex flex-col gap-1">
                  <label className="text-gray-400 text-[12px]">ID</label>
                  <span className="text-[15px]">
                    {communityDetails?.data?.communityId}
                  </span>
                </div>
                <div className="flex flex-col gap-1">
                  <label className="text-gray-400 text-[12px]">Name</label>
                  <span className="text-[15px]">
                    {communityDetails?.data?.name}
                  </span>
                </div>
                <div className="flex flex-col gap-1">
                  <label className="text-gray-400 text-[12px]">
                    General Contact Phone
                  </label>
                  <span className="text-[15px]">
                    {communityDetails?.data?.generalPhoneNo}
                  </span>
                </div>
                <div className="flex flex-col gap-1">
                  <label className="text-gray-400 text-[12px]">
                    Emergency Contact Number
                  </label>
                  <span className="text-[15px]">
                    {communityDetails?.data?.emergencyPhoneNo}
                  </span>
                </div>
                <div className="flex flex-col gap-1">
                  <label className="text-gray-400 text-[12px]">State</label>
                  <span className="text-[15px]">
                    {communityDetails?.data?.state}
                  </span>
                </div>
                <div className="flex flex-col gap-1">
                  <label className="text-gray-400 text-[12px]">City</label>
                  <span className="text-[15px]">
                    {communityDetails?.data?.city}
                  </span>
                </div>
                <div className="flex flex-col gap-1">
                  <label className="text-gray-400 text-[12px]">
                    # of Properties
                  </label>
                  <span
                    className={cn(
                      "text-[15px]",
                      isBom ? "underline cursor-pointer" : ""
                    )}
                    onClick={onShowProperty}
                  >
                    {communityDetails?.data?.totalProperties}
                  </span>
                </div>
                <div className="flex flex-col gap-1">
                  <label className="text-gray-400 text-[12px]">
                    # of Users
                  </label>
                  <span
                    className={cn(
                      "text-[15px]",
                      isBom ? "underline cursor-pointer" : ""
                    )}
                    onClick={onShowUsers}
                  >
                    {communityDetails?.data?.totalUsers}
                  </span>
                </div>
              </div>
              <div className="flex justify-end">
                <Button
                  variant="link"
                  className="px-0 text-white"
                  onClick={onViewMoreClick}
                >
                  {myCommunityCurrView == COMMUNITY ? "View Less" : "View More"}
                </Button>
              </div>
            </div>

            {myCommunityCurrView == COMMUNITY ? (
              <OwnerAddEditCommunity />
            ) : myCommunityCurrView == PROPERTIES ? (
              <OwnerProperties />
            ) : myCommunityCurrView == VIEW_PROPERTY ? (
              <OwnerAddEditProperty />
            ) : myCommunityCurrView == USERS ? (
              <OwnerUsers />
            ) : myCommunityCurrView == VIEW_USERS ? (
              <OwnerAddEditUser />
            ) : myCommunityCurrView == COMM_USERS ? (
              <OwnerUsersList />
            ) : (
              <></>
            )}
          </>
        )}
      </div>
    </div>
  );
};

export default Communities;
